import React from 'react';
import {Button, Form, Input, Pagination, Select, Space, Table, Typography} from 'antd';
import axios from '../../request/axios';
import moment from 'moment';
import OrderDetailsModal from '../order/OrderDetailsModal';
import DateRangePicker from '../../components/DateRangePicker';
import CustomerShopSelector from './components/CustomerShopSelector';
import ModelConstants from '../../constants/ModelConstants';

const {Option} = Select;
const {Text, Link} = Typography;

class TianmaoOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      records: [],
      product_status: 0,
      pagination: {page: 1, page_size: 15},
      total: 0
    };
  }

  componentDidMount() {
    this.loadData();
  }

  handleInputClear = (e) => {
    if (!e.target.value) this.loadData();
  }

  handlePaginationChange = (page, page_size) => {
    this.setState({
      pagination: {
        page: page,
        page_size: page_size
      }
    }, this.loadData);
  }

  loadData = () => {
    this.setState({
      loading: true
    });
    let values = this.formRef.getFieldsValue();
    let query_params = {...values, ...{date_range: [values.date_range[0].format('Y-M-D'), values.date_range[1].format('Y-M-D')]}, ...this.state.pagination};
    axios.get('customer-shop-orders/tianmao-orders', {params: query_params}).then((res) => {
      const {data} = res.data;
      this.setState({
        loading: false,
        records: data.data,
        total: data.total
      });
    });
  };

  resetForm = () => {
    this.formRef && this.formRef.resetFields();
    this.loadData();
  }

  render() {
    // 表格操作
    const operations = <div className='text-right'>
      <Pagination current={this.state.pagination.page} pageSize={this.state.pagination.page_size}
                  onChange={this.handlePaginationChange} showTotal={(total) => '共' + total + '条记录'}
                  total={this.state.total} pageSizeOptions={[15, 25, 50, 100]}/>
    </div>;

    return (
      <div>
        <div className='query-form-container'>
          <Form className='query-form' ref={ref => this.formRef = ref} onFinish={this.loadData}
                initialValues={{date_range: DateRangePicker.TODAY}}>
            <div className='query-form__inputs_container'>
              <Form.Item label='订单号' name='id'>
                <Input placeholder='天猫订单号/平台订单号' style={{width: 180}} onPaste={() => setTimeout(this.loadData, 10)}
                       onChange={this.handleInputClear}/>
              </Form.Item>
              <Form.Item label='充值账号' name='charge_account'>
                <Input placeholder='充值账号' style={{width: 160}} onPaste={() => setTimeout(this.loadData, 10)}
                       onChange={this.handleInputClear}/>
              </Form.Item>
              <Form.Item label='天猫合作商' name='coop_id'>
                <Input placeholder='天猫合作商' style={{width: 160}} onPaste={() => setTimeout(this.loadData, 10)}
                       onChange={this.handleInputClear}/>
              </Form.Item>
            </div>
            <div className='query-form__inputs_container'>
              <Form.Item label='天猫TSC' name='tsc'>
                <Input placeholder='天猫TSC' style={{width: 170}} onPaste={() => setTimeout(this.loadData, 10)}
                       onChange={this.handleInputClear}/>
              </Form.Item>
              <Form.Item label='订单状态' name='status'>
                <Select placeholder='选择订单状态' style={{width: 160}} onChange={this.loadData} allowClear>
                  <Option value='1'>待充值</Option>
                  <Option value='2'>提交成功</Option>
                  <Option value='3'>提交失败</Option>
                </Select>
              </Form.Item>
            </div>
            <div className='query-form__inputs_container'>
              <Form.Item label='下单日期' name='date_range'>
                <DateRangePicker onChange={this.loadData}/>
              </Form.Item>
            </div>
            <div className='query-form__operations'>
              <Space>
                <Button type='primary' htmlType='submit'>筛选</Button>
                <Link onClick={this.resetForm}>重置筛选条件</Link>
              </Space>
            </div>
          </Form>
        </div>
        <Table className='mt-4' rowKey='id' dataSource={this.state.records} loading={this.state.loading}
               pagination={false}>
          <Table.Column title='天猫订单号' dataIndex='id' key='id' align='center'
                        render={(value) => <Text copyable>{value}</Text>}/>
          <Table.Column title='天猫合作商' dataIndex='coop_id' key='coop_id' align='left'/>
          <Table.Column title='TSC' dataIndex='tsc' key='tsc' align='left'/>
          <Table.Column title='充值账号' dataIndex='charge_account' key='charge_account' align='left'/>
          <Table.Column title='订单状态' dataIndex='status' key='status' align='left' render={(value, record) =>
            <>
              {
                record.status === '1' ? <span style={{color:'grey'}}>待充值</span> :
                  record.status === '2' ? <span style={{color:'blue'}}>提交成功</span> :
                    record.status === '3' ? <span style={{color:'red'}}>提交失败</span> :
                      '-'
              }
            </>
          }/>
          <Table.Column title='状态信息' dataIndex='status_info' key='status_info' align='left' width={150}/>
          <Table.Column title='交易时间' dataIndex='created_at' key='created_at' align='center'
                        render={(value) => moment(value).format('Y-MM-DD HH:mm:ss')}/>
          <Table.Column title='平台订单号' dataIndex='order_id' key='order_id' align='center'
                        render={(value) => value ? <Link onClick={() => this.orderDetailsModal.openModal(value)}>{value}</Link> : '-'}/>
        </Table>
        <div className='mt-4'>{operations}</div>
        <OrderDetailsModal ref={ref => this.orderDetailsModal = ref}/>
      </div>
    );
  }
}

export default TianmaoOrders;